import { Component } from '@angular/core';
import { KYMW1400Model } from '../kymw1400.model';
import { RegistKomaService } from '../api-services/regist-koma.service';
import { KomaComponent } from './koma.component';
import { PageComponent } from './page.component';

@Component({
  selector: 'app-section',
  template: '',
})
export class SectionComponent {
  // コマのインスタンスを保持する配列（瀬尾）
  private _komaList: Array<KomaComponent> = new Array<KomaComponent>();

  // 描画するセクション情報
  public drawSectionSizeW = 0;
  public drawSectionSizeH = 0;
  public drawSectionPositionX = 0;
  public drawSectionPositionY = 0;

  public sectionId = String('');
  /** X位置(mm) */
  public positionX: number = null;
  /** Y位置(mm) */
  public positionY: number = null;
  /** 幅(mm) */
  public sizeW: number = null;
  /** 高さ(mm) */
  public sizeH: number = null;
  public divX = Number(1);							// 横のグリッド数
  public divY = Number(1);							// 縦のグリッド数

  private tempKomaId = Number(0);
  public page: PageComponent = null;
  /**
   * コンストラクタ
   */
  constructor(
    private kymw1400Model: KYMW1400Model,
  ) { }

  /**
   * セクションデータ設定
   *
   * @param sectionData:
   * @param pageWidth:
   * @param pageHeight:
   */
  public setData(sectionData: any): void {
    // データ初期化処理
    this.clear();

    // ページ情報取得
    this.sectionId = String(sectionData.SectionID);
    this.positionX = parseFloat(sectionData.PositionX);
    this.positionY = parseFloat(sectionData.PositionY);
    this.sizeW = parseFloat(sectionData.SizeW);
    this.sizeH = parseFloat(sectionData.SizeH);
    this.divX = Number(sectionData.DivX);
    this.divY = Number(sectionData.DivY);

    this._komaList = [];	// コマリスト初期化
    if (sectionData.KomaInfo != null) {
      // コマが1つの場合でも配列として処理する
      const komaList: Array<any> = sectionData.KomaInfo;
      if (komaList !== undefined) {
        komaList.forEach(koma => {
          // コマのインスタンスを保持するように変更
          const komaInstance: KomaComponent = new KomaComponent;
          komaInstance.page = this.page;
          komaInstance.section = this;
          komaInstance.setData(koma);
          this._komaList.push(komaInstance);
        });
      }
    }
  }

  /**
   * コマのインスタンスの配列を返す
   */
  public get komaList(): Array<KomaComponent> {
    return this._komaList;
  }

  /**
   * コマ情報を追加する
   */
  public addKomaData(komaInfoData: Array<any>): void {
    const komaInfoList: Array<any> = komaInfoData;
    komaInfoList.forEach(komaInfo => {
      const koma: KomaComponent = new KomaComponent();
      koma.setData(komaInfo);
      this._komaList.push(koma);
    });
  }

  /**
   * コマ情報更新
   */
  public updateKomaData(komaDatas: any[]): boolean {
    for (let i = Number(0); i < this.komaList.length; i++) {
      const komaData = komaDatas.find(k => k.KomaID === this.komaList[i].komaId);
      if (komaData) {
        this.komaList[i].setData(komaData);
        // 最新情報でコマを描画する
        this.page.drawKoma(this.komaList[i]);
        return true;
      }
    }
    return false;
  }

  /**
   * 選択したコマの通知を受けて再度表示を指示する
   * @param komaId:コマID
   */
  public setSelectedKoma(komaId: string): void {
    this.komaList.forEach(koma => {
      if (koma.komaId === komaId) {
        koma.selected = true;
      } else {
        koma.selected = false;
      }
    });
  }

  /**
   * 新しいコマを追加する
   *
   * @return コマ配置可否
   */
  public addNewKoma(registKomaService: RegistKomaService, drawKoma: Function): boolean {
    const komaInfoList = this.getCandidateKomaInfoList();
    // グリッドの行を全てチェックする（列単位）
    for (let i = Number(0); i < komaInfoList.length; i++) {
      if (!this.isCollisionKomaInfo(komaInfoList[i])) {
        const komaComp: KomaComponent = new KomaComponent();
        komaComp.setData(komaInfoList[i]);
        komaComp.section = this;
        komaComp.page = this.page;

        const vo = this.kymw1400Model.getRegistKomaVO(this.sectionId, komaComp);
        registKomaService.execute(
          komaComp,
          vo,
          (koma: KomaComponent) => {
            this.addNewKomaSuccess(koma);
            drawKoma(koma);
          });

        return true;
      }
    }
    return false;
  }

  /**
   * 新しいコマを追加成功時
   */
  public addNewKomaSuccess(koma: KomaComponent): void {
    this._komaList.push(koma);
  }

  /**
   * 追加可能な全てのコマ情報を返却する
   */
  public getAllEmptyKoma(): Array<any> {
    const returnList: Array<any> = new Array<any>();
    this.getCandidateKomaInfoList().forEach(komaInfo => {
      if (!this.isCollisionKomaInfo(komaInfo, returnList)) {
        // コマ生成
        const koma: KomaComponent = new KomaComponent();
        koma.setData(komaInfo);

        // コマ追加
        returnList.push(koma);
      }
    });
    return returnList;
  }

  /**
   * 追加可能なコマのカウントを取得する
   *
   * @return int:追加可能コマカウント
   */
  public getAddAbleKomaCnt(): number {
    let returnCnt = Number(0);
    // グリッドの行を全てチェックする（列単位）
    this.getCandidateKomaInfoList().forEach(komaInfo => {
      if (!this.isCollisionKomaInfo(komaInfo)) {
        returnCnt++;
      }
    });
    return returnCnt;
  }

  /**
   * 衝突チェックを行う
   *
   * return Boolean:TRUE衝突、FALSE:衝突無し
   */
  private isCollisionKomaInfo(komaInfo: any, extraKomaList: Array<any> = null): boolean {
    for (let i = Number(0); i < this.komaList.length; i++) {
      if (this.isCollisionRec(this.komaList[i], komaInfo)) {
        return true;
      }
    }

    if (extraKomaList != null) {
      for (let i = Number(0); i < extraKomaList.length; i++) {
        if (this.isCollisionRec(extraKomaList[i], komaInfo)) {
          return true;
        }
      }
    }

    return false;
  }

  /**
   * 二つの矩形の衝突判定を行う
   *
   * @param a 衝突判定対象領域１
   * @param b 衝突判定対象領域２
   *
   * @return true:aとbが衝突, false:衝突していない
   */
  private isCollisionRec(a: any, b: any): boolean {
    // 下(bottom)と右(right)は領域範囲を1px分出るため-1する
    if (!((a.positionX + a.sizeW).toFixed(4) <= Number(b.PositionX[0]).toFixed(4)) &&
      !((Number(b.right[0]).toFixed(4)) <= a.positionX.toFixed(4)) &&
      !((a.positionY + a.sizeH).toFixed(4) <= Number(b.PositionY[0]).toFixed(4)) &&
      !((Number(b.bottom[0]).toFixed(4)) <= a.positionY.toFixed(4))) {
      return true;
    }
    return false;
  }

  /**
   * 追加可能なコマリストを取得する
   *
   * @return ArrayCollection:追加可能なコマリスト
   */
  private getCandidateKomaInfoList(): Array<any> {
    const komaInfoList: Array<any> = new Array<any>();

    for (let rowCnt = Number(0); rowCnt < this.divY * 2 - 1; rowCnt++) {
      for (let colCnt = Number(0); colCnt < this.divX * 2 - 1; colCnt++) {
        const komaInfo: any = new Object();
        komaInfo.KomaID = [String(this.tempKomaId++)];
        komaInfo.SizeW = [String(1 / this.divX)];
        komaInfo.SizeH = [String(1 / this.divY)];
        komaInfo.PositionX = [String(1 / this.divX * 0.5 * colCnt)];
        komaInfo.PositionY = [String(1 / this.divY * 0.5 * rowCnt)];
        komaInfo.PromotionName = [String('')];

        komaInfo.X = [String(komaInfo.PositionX * this.drawSectionSizeW)];
        komaInfo.Y = [String(komaInfo.PositionY * this.drawSectionSizeH)];
        komaInfo.Width = [String(komaInfo.SizeW * this.drawSectionSizeW)];
        komaInfo.Height = [String(komaInfo.SizeH * this.drawSectionSizeH)];
        komaInfo.right = [1 / this.divX * (0.5 * colCnt + 1)];
        komaInfo.bottom = [1 / this.divY * (0.5 * rowCnt + 1)];

        komaInfoList.push(komaInfo);
      }
    }

    return komaInfoList;
  }

  /**
   * コマが選択されているのか
   *
   * @return コマ選択
   */
  public isSelectedKoma(): boolean {
    for (let i = Number(0); i < this.komaList.length; i++) {
      if (this.komaList[i].selected) {
        return true;
      }
    }
    return false;
  }

  /**
   * 選択コマ情報を削除する
   */
  public deleteSelectedKoma(): boolean {
    for (let i = Number(0); i < this.komaList.length; i++) {
      if (this.komaList[i].selected) {
        this.komaList.splice(i, 1);
        return true;
      }
    }
    return false;
  }


  /**
   * 全コマ情報を削除する
   */
  public deleteAllKoma(): void {
    // super.removeAllChildren();
    this._komaList = new Array<KomaComponent>();
  }

  /**
   * 移動元コマ情報を削除し、移動先コマ情報を登録する
   */
  public moveKomaData(komaFr: KomaComponent, komaTo: KomaComponent): boolean {
    for (let i = Number(0); i < komaFr.section.komaList.length; i++) {
      if (komaFr.section.komaList[i].komaId === komaFr.komaId) {
        komaFr.section._komaList.splice(i, 1);
        komaTo.section._komaList.push(komaTo);
        return true;
      }
    }
    return false;
  }

  /**
   * 選択されたコマを返却する
   *
   * @return Koma:コマ
   */
  public selectedKoma(): KomaComponent {
    for (let i = Number(0); i < this.komaList.length; i++) {
      if (this.komaList[i].selected) {
        return this.komaList[i];
      }
    }
    return null;
  }


  /**
   * ページ情報をクリアする
   */
  public clear(): void {
    this.sectionId = '';
    this.sizeW = 0;
    this.sizeH = 0;
    this.divX = 1;
    this.divY = 1;
  }

  /**
   * Pコードが存在するかチェックを行う
   */
  public hasPcode(pcode: string): boolean {
    for (let i = Number(0); i < this.komaList.length; i++) {
      if (this.komaList[i].hasPcode(pcode)) {
        return true;
      }
    }
    return false;
  }

}
